import { COUNTRY_CODE } from '@cemex-core/cmx-api';

// USED FOR USER INITIALS
export const RTL_COUNTRIES: COUNTRY_CODE[] = [COUNTRY_CODE.ISRAEL];

// USED TO SET DIRECTION BASED ON LANGUAGE
export const RTL_LANGUAGES: string[] = ['he_IL'];
